<script>
import Datatable from "@/router/layouts/table-datatable.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: { Datatable },
  data() {
    return {
      soalBagiValidator: {
        loading: true,
        list: [],
        columns: [
          { width: "30%", label: "Status Soal", name: "-" },
          { width: "17%", label: "Pilihan Ganda", name: "-" },
          { width: "17%", label: "Benar Salah", name: "-" },
          { width: "18%", label: "Menjodohkan", name: "-" },
          { width: "18%", label: "Text", name: "-" },
        ],
        chart: { options: {}, series: [], labels: [] },
      },
      kompetensiBagiValidator: {
        loading: true,
        list: [],
        columns: [
          { width: "40%", label: "Kode Kompetensi", name: "-" },
          { width: "20%", label: "Pending", name: "-" },
          { width: "20%", label: "Revisi", name: "-" },
          { width: "20%", label: "Approved", name: "-" },
        ],
        chart: { options: {}, series: [], labels: [] },
      },
    };
  },

  mounted() {
    this.fetchSoalBagiValidator();
    this.fetchKompetensiBagiValidator();
  },

  methods: {
    async fetchSoalBagiValidator() {
      this.soalBagiValidator.loading = true;
      await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "dashboard/soal-bagi-validator",
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      }).then((res) => {
        if (res.data.meta.code != 200) {
          Swal.fire({ icon: "error", title: "Gagal get data soal bagi validator" });
          return;
        }
        this.soalBagiValidator.list = res.data.data.list;
        this.soalBagiValidator.chart.series = res.data.data.series;
        this.soalBagiValidator.chart.labels = res.data.data.label;
        this.soalBagiValidator.loading = false;
        this.setSoalBagiValidatorChart();
      });
    },

    setSoalBagiValidatorChart() {
      this.soalBagiValidator.chart.options = {
        chart: { type: "bar" },
        plotOptions: {
          bar: { horizontal: false, columnWidth: "55%", borderRadius: 5, borderRadiusApplication: "end" },
        },
        title: { text: "Soal Bagi Validator" },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 2, colors: ["transparent"] },
        xaxis: { categories: this.soalBagiValidator.chart.labels },
        yaxis: { title: { text: "Jumlah Soal" } },
        fill: { opacity: 1 },
        legend: { position: "top" },
        tooltip: { y: { formatter: (val) => val + " soal" } },
      };
    },

    async fetchKompetensiBagiValidator() {
      this.kompetensiBagiValidator.loading = true;
      await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "dashboard/kompetensi-bagi-validator",
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      }).then((res) => {
        if (res.data.meta.code != 200) {
          Swal.fire({ icon: "error", title: "Gagal get data kompetensi bagi validator" });
          return;
        }
        this.kompetensiBagiValidator.list = res.data.data.list;
        this.kompetensiBagiValidator.chart.series = res.data.data.series;
        this.kompetensiBagiValidator.chart.labels = res.data.data.label;
        this.kompetensiBagiValidator.loading = false;
        this.setKompetensiBagiValidatorChart();
      });
    },

    setKompetensiBagiValidatorChart() {
      this.kompetensiBagiValidator.chart.options = {
        chart: { type: "bar" },
        plotOptions: {
          bar: { horizontal: false, columnWidth: "55%", borderRadius: 5, borderRadiusApplication: "end" },
        },
        title: { text: "Kompetensi Bagi Validator" },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 2, colors: ["transparent"] },
        xaxis: {
          categories: this.kompetensiBagiValidator.chart.labels,
          labels: { rotate: -45, style: { fontSize: "12px" }, trim: true },
        },
        yaxis: { title: { text: "Jumlah" } },
        fill: { opacity: 1 },
        legend: { position: "top" },
        tooltip: { y: { formatter: (val) => val } },
      };
    },
  },
};
</script>

<template>
  <div>
    <!-- Baris 1: Datatable -->
    <div class="row mb-3">
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Soal Bagi Validator</div>
            <datatable :columns="soalBagiValidator.columns">
              <tbody>
                <tr v-if="soalBagiValidator.loading">
                  <td colspan="99" class="text-center">
                    <i class="fas fa-spinner fa-spin"></i> Loading
                  </td>
                </tr>
                <tr v-else-if="soalBagiValidator.list.length < 1">
                  <td colspan="99" class="text-center">Data tidak tersedia</td>
                </tr>
                <tr v-else v-for="(row, key) in soalBagiValidator.list" :key="key">
                  <td>{{ row.status }}</td>
                  <td class="text-center">{{ row.pg }}</td>
                  <td class="text-center">{{ row.bs }}</td>
                  <td class="text-center">{{ row.mtc }}</td>
                  <td class="text-center">{{ row.txt }}</td>
                </tr>
              </tbody>
            </datatable>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Kompetensi Bagi Validator</div>
            <datatable :columns="kompetensiBagiValidator.columns">
              <tbody>
                <tr v-if="kompetensiBagiValidator.loading">
                  <td colspan="99" class="text-center">
                    <i class="fas fa-spinner fa-spin"></i> Loading
                  </td>
                </tr>
                <tr v-else-if="kompetensiBagiValidator.list.length < 1">
                  <td colspan="99" class="text-center">Data tidak tersedia</td>
                </tr>
                <tr v-else v-for="(row, key) in kompetensiBagiValidator.list" :key="key">
                  <td>{{ row.kode_kompetensi }}</td>
                  <td class="text-center">{{ row.pending }}</td>
                  <td class="text-center">{{ row.revisi }}</td>
                  <td class="text-center">{{ row.approved }}</td>
                </tr>
              </tbody>
            </datatable>
          </div>
        </div>
      </div>
    </div>

    <!-- Baris 2: Chart -->
    <div class="row mb-3">
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <apexchart
              v-if="soalBagiValidator.chart.series.length > 0"
              class="apex-charts"
              :options="soalBagiValidator.chart.options"
              :series="soalBagiValidator.chart.series"
            />
            <div v-else-if="!soalBagiValidator.loading" class="text-center py-4 text-muted">
              Tidak ada data untuk ditampilkan pada grafik.
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <apexchart
              v-if="kompetensiBagiValidator.chart.series.length > 0"
              class="apex-charts"
              :options="kompetensiBagiValidator.chart.options"
              :series="kompetensiBagiValidator.chart.series"
            />
            <div v-else-if="!kompetensiBagiValidator.loading" class="text-center py-4 text-muted">
              Tidak ada data untuk ditampilkan pada grafik.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
